import { render, staticRenderFns } from "./advertisingList.vue?vue&type=template&id=8ce32fac&scoped=true"
import script from "./advertisingList.vue?vue&type=script&lang=js"
export * from "./advertisingList.vue?vue&type=script&lang=js"
import style0 from "./advertisingList.vue?vue&type=style&index=0&id=8ce32fac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce32fac",
  null
  
)

export default component.exports